import { render } from "./BatchClassAttributesForm.vue?vue&type=template&id=8b8b922c&scoped=true&ts=true"
import script from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"

import "./BatchClassAttributesForm.vue?vue&type=style&index=0&id=8b8b922c&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8b922c"]])

export default __exports__